import API from '../../services/API';
import { configs } from '../../constants/configs/configs';
import { setError, startSpinner, stopSpinner } from '../common/actionCreators';
import { SIDENAV_ACTION_TYPES } from '../../constants/actionTypes/sideNavActionTypes';

const {
    endpoints: { GET_UNREAD_NOTIFICATION_COUNT },
} = configs;

export const setSideNavdetails = payload => ({
    type: SIDENAV_ACTION_TYPES.SET_SIDE_NAV_DETAILS,
    payload: payload,
});

export const setSideNavUnreadMessageCount = payload => ({
    type: SIDENAV_ACTION_TYPES.SET_SIDE_NAV_UNREAD_MESSAGE_COUNT,
    payload: payload,
});
const actions = { setError, startSpinner, stopSpinner };
export const fetchSideNavUnreadNotificationCount = (part, id) => async (dispatch, getState) => {
    const isEncrypted = isNaN(id);
    const endpoint = GET_UNREAD_NOTIFICATION_COUNT.processReplacements({ part, id, isEncrypted });
    const data = await API.getData(endpoint, dispatch, actions, false, getState());
    if (data && data.success) {
        dispatch(setSideNavUnreadMessageCount(data.payload));
        return Promise.resolve(data.payload);
    }
};